import { useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useGetAdminMetricsQuery } from '../../api/metricsApi';
import { useToast } from '../../context/ToastContext';
import { errMsg } from '../../utils/errMsg';
import s from '../../styles/shared/page.module.css';
import table from '../../styles/shared/table.module.css';

export default function MetricsPage() {
  const {
    data: metrics,
    isLoading,
    isError,
    error,
  } = useGetAdminMetricsQuery(undefined, { refetchOnMountOrArgChange: true });
  const showToast = useToast();

  useEffect(() => {
    if (isError) showToast('error', 'Metrics', errMsg(error, 'Could not load metrics.'));
  }, [isError, error, showToast]);

  const rows = metrics
    ? [
        { label: 'Organizations', value: metrics.organizations.total },
        { label: 'Managers', value: metrics.staff.managers },
        { label: 'Hosts', value: metrics.staff.hosts },
        { label: 'Groups', value: metrics.groups.total },
        {
          label: 'Subscribers',
          value: metrics.subscribers.total,
          sublabel: `${metrics.subscribers.verified} verified`,
        },
        { label: 'Giveaways', value: metrics.giveaways.total },
      ]
    : [];

  return (
    <div className={s.page}>
      <div className={s.header}>
        <div>
          <h1>Metrics</h1>
          <p className={`${s.subtitle} textMuted`}>
            Platform-wide totals across every organization.
          </p>
        </div>
      </div>

      <div className={`${table.tableWrapper} ${s.metricsTable}`}>
        <DataTable
          value={rows}
          loading={isLoading}
          emptyMessage="No metrics yet."
          responsiveLayout="stack"
        >
          <Column
            field="label"
            header="Metric"
            style={{ width: '320px' }}
            body={(r) => <div className={`${table.cellInsider} ${s.metricCell}`}>{r.label}</div>}
          />
          <Column
            header="Value"
            style={{ width: '320px' }}
            body={(r) => (
              <div className={`${table.cellInsider} ${s.metricCell}`}>
                <span className={s.metricValue}>{r.value}</span>
                {r.sublabel && <span className={s.metricSublabel}>{r.sublabel}</span>}
              </div>
            )}
          />
        </DataTable>
      </div>
    </div>
  );
}
